<template>
  <div v-bind:class="{ printVersion: printVersion }">
    <el-row type="flex" justify="center">
      <el-col :span="20">
        <el-alert v-if="userIsAdmin && advisorComment" title="Comentario de asesor" type="info" :description="advisorComment" show-icon :closable="false">
        </el-alert>
        <portfolio-header :general-data="portfolioAnalysis"></portfolio-header>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col :span="24">
        <asset-allocation v-bind:printableVersion="printableVersion" v-bind:donnut-data="assetAllocation.data" :info-data="assetAllocation.titles" v-bind:donnut-labels="assetAllocation.labels" :colors="assetAllocation.dataColors">
        </asset-allocation>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col :span="marketInformationTitleSpan" class="sectionContainer">
        <span class="section-title">Información de mercado</span>
      </el-col>
      <el-col :span="marketInformationSpan" class="sectionContainer">
        <representative-positions v-bind:printableVersion="printableVersion" v-bind:graph_data="marketInformationData">
        </representative-positions>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col :span="20" class="sectionContainer">
        <span class="section-title">Posiciones Representativas</span>
        <representative-positions class="representative-positions-table" v-bind:printableVersion="printableVersion" v-bind:graph_data="representativePositions" v-bind:percentage_color="'#001F5C'"></representative-positions>
      </el-col>
    </el-row>
    <!-- Footer -->

      <el-row type="flex" justify="center">
        <el-col :span="20" class="sectionContainer">
          <div class="avoid-page-break">
          <span class="section-title" v-if="portfolioComments.length > 0 && printVersion">Comentarios de Portafolio</span>
          <comments :is-portfolio-overview="true" :comments="portfolioComments" :is-print-version="printVersion"></comments>
          </div>
        </el-col>
      </el-row>

      <el-row type="flex" justify="center" v-if="!printVersion">
        <el-col :span="20">
          <portfolio-footer :creation-date="portfolioAnalysis.updatedDataAt"></portfolio-footer>
        </el-col>
      </el-row>

  </div>
</template>

<script>
import PortfolioHeader from "./PortfolioHeader";
import AssetAllocation from "./DonnutChartSection";
import RepresentativePositions from "./TableData";
import CommentsSection from "./CommentsSection";
import PortfolioFooter from "./PortfolioFooter";
import { getPortfolioAnalysis, getAdvisorData } from "@/graphql";
export default {
  name: "PortfolioOverview",
  components: {
    "portfolio-header": PortfolioHeader,
    "asset-allocation": AssetAllocation,
    "representative-positions": RepresentativePositions,
    comments: CommentsSection,
    "portfolio-footer": PortfolioFooter
  },
  props: {
    externalMarketInformationTitleSpan: Number,
    externalmarketInformationSpan: Number,
    printableVersion: false
  },
  created() {
    const userId = localStorage.getItem("user_id");
    if (!this.advisorId) {
      this.$apollo
        .query({
          query: getAdvisorData,
          variables: {
            id: userId
          },
          fetchPolicy: "cache-first"
        })
        .then(data => this.$store.dispatch("saveUserData", data.data));
    }
  },
  mounted() {
    this.getPortfolioData(this.$route.params.id);
    if (this.externalMarketInformationTitleSpan) {
      this.marketInformationTitleSpan = this.externalMarketInformationTitleSpan;
    }
    if (this.externalmarketInformationSpan) {
      this.marketInformationSpan = this.externalmarketInformationSpan;
    }
    if (this.printableVersion == true) {
      this.printVersion = true;
    }
  },
  data() {
    return {
      printVersion: false,
      marketInformationTitleSpan: 7,
      marketInformationSpan: 13,
      assetAllocation: {},
      marketInformation: [],
      portfolioComments: [],
      advisorComment: "",
      labels: {
        month: '',
        lastYear: ''
      }
    };
  },
  computed: {
    portfolioAnalysis: function() {
      return this.$store.getters.currentPortfolioAnalysis;
    },
    userIsAdmin: function() {
      return this.$store.getters.userIsAdmin;
    },
    representativePositions: function() {
      return {
        titles: [
          {
            prop: "assetName",
            label: ""
          },
          {
            prop: "assetClass",
            label: "Asset Class"
          }
        ],
        data: this.$store.getters.currentPortfolioAnalysis
          .representativePositions,
        percentage: true,
        displayTotalLabel: true
      };
    },
    marketInformationData: function() {
      return {
        titles: [
          {
            prop: "name",
            label: "Rendimiento"
          },
          {
            prop: "monthYield",
            label: `Mensual ${this.labels.month} ${this.labels.lastYear}`
          },
          {
            prop: "accumulatedYield",
            label: `Acumulado ${this.labels.lastYear}`
          }
        ],
        data: this.marketInformation
      };
    }
  },
  watch: {
    portfolioAnalysis: function(value) {
      if (value) {
        this.getChartData(value);
        this.portfolioComments = value.portfolioComments;
        this.advisorComment = value.advisorComment;
        this.marketInformation = value.marketInformation;
        this.labels = value.labels;
      }
    }
  },
  methods: {
    getPortfolioData(id) {
      this.$apollo
        .query({
          query: getPortfolioAnalysis,
          variables: {
            id
          },
          fetchPolicy: "network-only"
        })
        .then(data => this.analysisSuccessHandler(data.data.portfolioAnalysis))
        .catch(error => {
          this.$message({
            type: "error",
            message: "Ocurrió un error, intenta más tarde"
          });
        });
    },
    analysisSuccessHandler(analaysisData) {
      this.$store.dispatch("saveCurrentPortfolioAnalysis", analaysisData);
    },
    getChartData(portfolioAnalysis) {
      const objectKeys = [
        "fondosRF",
        "fondosRV",
        "deuda",
        "capitales",
        "estructurados"
      ];
      const placeholders = [
        "Fondos RF",
        "Fondos RV",
        "Deuda",
        "Capitales",
        "Estructurados"
      ];
      const colors = ["#C2BFE0", "#FDB462", "#97E3D6", "#B3DE69", "#FB8070"];
      let data = [];
      let labels = [];
      let titles = [];
      let dataColors = [];
      for (const index in objectKeys) {
        const id = objectKeys[index];
        const label = placeholders[index];
        const color = colors[index];
        if (portfolioAnalysis[id].amount !== 0) {
          data.push(portfolioAnalysis[id].percentage);
          labels.push(label);
          dataColors.push(color);
          const titleObject = {
            name: label,
            percentage: portfolioAnalysis[id].percentage,
            amount: portfolioAnalysis[id].amount,
            id: id.toLowerCase()
          };
          titles.push(titleObject);
        }
      }
      this.assetAllocation = {
        data,
        labels,
        titles,
        dataColors
      };
    }
  }
};
</script>

<style scoped>
.sectionContainer {
  border-top: 1px solid#E9E9E9;
  padding-top: 25px;
}
.section-title {
  font-size: 18px;
  font-weight: 500;
}
.detail-title {
  font-size: 10px;
  font-weight: 600;
}
.portfolioComment-toggle {
  color: #4a4a4a;
  font-size: 14px;
  font-weight: bold;
}
.el-alert {
  margin-top: 20px;
}
/* For the subtitles */
.printVersion .sectionContainer {
  padding-top: 0px !important;
}
.printVersion .section-title {
  position: relative;
  bottom: 28px;
  margin-top: 26px;
  font-size: 14px;
  font-weight: 600;
  color: #3e67de;
}

.representative-positions-table {
  position: relative;
  bottom: 14px;
}
</style>




// WEBPACK FOOTER //
// src/components/PortfolioOverview.vue